import { LocaleData, LocaleConfig } from '../types';

export const config: LocaleConfig = {
    id: 'ms',
    fullName: 'Malay',
    nativeName: 'Melayu',
    direction: 'ltr'
};

const translations: LocaleData = {
    title: "ArgVoid",
    landing_title: "Sesuatu yang Menakjubkan Akan Datang",
    landing_subtitle: "ArgVoid ialah studio pembangunan aplikasi dan permainan. Nantikan, perkara baharu akan datang tidak lama lagi!",
    select_language: "Pilih Bahasa",
    search_placeholder: "Cari bahasa...",
    terms_title: "Syarat Perkhidmatan",
    policy_title: "Dasar Privasi",
    cookies_title: "Dasar Kuki",
    terms_content: `
        <strong>1. Penerimaan Terma</strong><br>
        Dengan mengakses ArgVoid, Syarat Perkhidmatan ini diterima. Jika syarat ini tidak dipersetujui, perkhidmatan tersebut tidak boleh digunakan.<br><br>

        <strong>2. Penggunaan Platform</strong><br>
        ArgVoid dan aplikasinya disediakan "seadanya" untuk tujuan maklumat dan kreatif. Perkhidmatan ini mesti digunakan hanya untuk tujuan yang sah.<br><br>

        <strong>3. Kelakuan Terlarang</strong><br>
        Memanfaatkan kelemahan tapak, menghantar spam atau mencuba akses tanpa kebenaran kepada infrastruktur adalah dilarang sama sekali.<br><br>

        <strong>4. Penafian</strong><br>
        Platform dan perkhidmatan boleh diubah suai pada bila-bila masa tanpa notis. Tiada jaminan diberikan mengenai masa beroperasi atau ketersediaan perkhidmatan.
    `,
    policy_content: `
        <strong>1. Pengumpulan Maklumat</strong><br>
        Platform ini tidak memerlukan pengesahan pengguna atau penciptaan akaun pada masa ini. Tiada maklumat pengenalan peribadi (seperti nama atau alamat e-mel) dikumpulkan secara aktif daripada pelawat.<br><br>

        <strong>2. Data Penggunaan</strong><br>
        Analitik asas tanpa nama boleh dikumpulkan untuk memahami trafik tapak dan menambah baik aplikasi. Data ini tidak dipautkan kepada identiti pengguna individu.<br><br>

        <strong>3. Perkhidmatan Pihak Ketiga</strong><br>
        Pembekal pihak ketiga boleh digunakan untuk perkhidmatan pengehosan dan analitik. Amalan privasi penyedia masing-masing ini mengawal data tanpa nama yang diproses pada infrastruktur mereka.<br><br>

        <strong>4. Keselamatan Data</strong><br>
        Langkah keselamatan yang munasabah dilaksanakan untuk melindungi platform. Walau bagaimanapun, tiada kaedah penghantaran melalui Internet adalah selamat sepenuhnya.<br><br>
    `,
    cookies_content: `
        <strong>1. Apakah itu Kuki dan Storan Tempatan?</strong><br>
        Kuki dan storan setempat penyemak imbas ialah fail data kecil yang disimpan pada peranti untuk mengingati pilihan konfigurasi merentas lawatan.<br><br>

        <strong>2. Tujuan Penggunaan</strong><br>
        Penyemak Imbas LocalStorage digunakan secara ketat untuk menyimpan tetapan konfigurasi, seperti:<br>
        - Pilihan bahasa<br>
        - Konfigurasi antara muka pengguna (cth., susun atur atau tetapan tema)<br>
        - Cache aplikasi sementara<br><br>

        <strong>3. Tiada Penjejakan</strong><br>
        Kuki dan storan tempatan tidak digunakan untuk tujuan pengiklanan atau penjejakan pihak ketiga. Semua data yang disimpan adalah semata-mata untuk fungsi teras platform.<br><br>

        <strong>4. Kawalan</strong><br>
        Data penyemak imbas boleh dikosongkan pada bila-bila masa melalui tetapan penyemak imbas, yang akan menetapkan semula sebarang konfigurasi setempat.
    `,
    cookie_consent_text: "Kami menggunakan kuki asas untuk memastikan tapak web berfungsi dengan betul, seperti memastikan sesi anda aktif, menyimpan pilihan bahasa anda dan konfigurasi tersuai yang lain.",
    read_policy: "Baca Dasar Kuki",
    support_title: "Hubungi Sokongan",
    support_subject_label: "Subjek",
    support_message_label: "Mesej",
    support_submit_button: "Hantar Mesej",
    support_hint: "Nota: Ini akan membuka aplikasi e-mel lalai anda untuk menghantar mesej.",
    support_success_msg: "Membuka apl e-mel anda...",
    support_error_msg: "Gagal menghantar mesej. Sila cuba lagi kemudian.",
    explorer_title: "Penjelajah",
    history_title: "Sejarah",
    animation_title: "Animasi",
    config_title: "Konfigurasi",
    tool_mouse: "Pilih (Ctrl+M)",
    tool_brush: "Berus (Ctrl+B)",
    tool_brush_mode: "Mod Togol (Pepejal/Jelas)",
    tool_eraser: "Pemadam (Ctrl+E)",
    tool_brush_size: "Laraskan Saiz Berus",
    tool_bucket: "Isi (Ctrl+F)",
    tool_eyedropper: "Penitis mata",
    tool_grid: "Grid (Ctrl+Shift+B)",
    tool_rotate: "Putar (Ctrl+Shift+R)",
    tool_flip_h: "Balikkan H (Ctrl+Shift+H)",
    tool_flip_v: "Balik V (Ctrl+Shift+V)",
    tool_transpose: "Transpose (Ctrl+Shift+T)",
    label_width: "Lebar",
    label_height: "Ketinggian",
    label_frames: "Bilangan Bingkai",
    label_animation: "Gaya Animasi",
    label_background_color: "Warna Latar Belakang",
    label_interval: "Selang waktu",
    tool_anim_config: "Konfigurasi Animasi",
    label_new_width: "Lebar Baru",
    label_new_height: "Ketinggian Baru",
    label_apply: "Mohon",
    label_colors: "warna",
    label_size: "Saiz",
    label_tolerance: "Toleransi",
    val_horizontal: "Mendatar",
    val_vertical: "Menegak",
    val_sequence: "Urutan",
    val_bounce: "melantun",
    val_random: "rawak",
    val_solid: "Padat",
    val_clear: "Jelas",
    action_add_sheet: "Lembaran Baru",
    action_import: "Import",
    action_export: "Eksport",
    action_sort_projects: "Isih",
    sort_date_old: "Tertua Pertama",
    sort_date_new: "Terbaharu Pertama",
    sort_name_az: "Nama (A-Z)",
    sort_name_za: "Nama (Z-A)",
    action_new_sprite: "Sprite baharu",
    action_new_project: "Projek Baru",
    modal_save_all_title: "Simpan Semua Perubahan",
    modal_save_all_desc: "Pilih aset untuk disimpan:",
    modal_save_selected: "Simpan Dipilih",
    action_saved: "Disimpan",
    modal_create_sprite_title: "Cipta Sprite Baharu",
    modal_create_project_title: "Buat Projek Baharu",
    modal_add_sheet_title: "Tambah Helaian Baharu",
    modal_rename_sheet_title: "Namakan semula Helaian",
    modal_rename_sprite_title: "Namakan semula Sprite",
    modal_delete_sprite_title: "Padam Sprite",
    modal_delete_project_title: "Padamkan Projek",
    modal_delete_sheet_title: "Padam Helaian",
    placeholder_sprite_name: "Nama",
    placeholder_project_name: "Nama",
    placeholder_sheet_name: "Nama",
    placeholder_new_name: "Nama Baru",
    action_create: "Buat",
    action_add: "Tambah",
    action_rename: "Namakan semula",
    action_duplicate: "Pendua",
    action_delete: "Padam",
    action_cancel: "Batal",
    confirm_delete_sprite: "Adakah anda pasti mahu memadamkan sprite ini?",
    confirm_delete_project: "Adakah anda pasti mahu memadamkan projek ini? Semua sprite akan dikeluarkan.",
    confirm_delete_sheet: "Adakah anda pasti mahu memadamkan helaian ini?",
    err_select_sprite: "Sila pilih sprite dahulu.",
    err_select_project: "Sila pilih projek dahulu.",
    err_name_empty: "Nama tidak boleh kosong.",
    err_sprite_exists: "Sprite dengan nama itu sudah wujud.",
    err_project_exists: "Projek dengan nama itu sudah wujud.",
    err_no_content: "Tiada kandungan untuk disimpan.",
    err_no_changes: "Tiada perubahan untuk disimpan.",
    err_delete_last_sheet: "Tidak boleh memadam helaian terakhir.",
    err_extract_frames: "Tidak dapat mengeluarkan sebarang bingkai.",
    err_indexeddb: "Gagal menyimpan secara setempat. Penyemak imbas anda mungkin tidak menyokong IndexedDB.",
    msg_upload_success: "Muat Naik Berjaya: {0}",
    msg_upload_failed: "Muat Naik Gagal: {0}",
    msg_save_success: "Simpan berjaya.",
    msg_saving: "Menyimpan...",
    msg_multi_save_result: "{0} aset disimpan. {1} kegagalan.",
    menu_title: "Menu",
    menu_save: "Jimat",
    menu_save_all: "Simpan Semua",
    menu_support: "Hubungi Sokongan",
    label_local_storage: "Storan Tempatan",
    label_sign_in: "Log Masuk",
    modal_export_title: "Eksport Sprite",
    label_filename: "Nama fail",
    label_format: "Format",
    action_export_confirm: "Eksport",
};

export default translations;
